<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Service in Progress</h4>
</div>
<div class="modal-body">
    <p>This service is currently in Active status. Some work may be lost if you proceed.</p>
    <p>Are you sure you want to unassign it?</p>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" aria-label="Close" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button class="btn--accent" type="submit" data-bs-dismiss="modal" (click)="accept()">Unassign</button>
    </div>
</div>
